// import React, { useState } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import Modal from '../Modal/Modal';
// import axios from '../../api/axiosInstance';
// import Tooltip from '@mui/material/Tooltip';
// import { exportToExcel } from '../../utils/exportToExcel';
// import SaveTestCaseModal from '../Modal/SaveTestCaseModal';
// import ApprovedScenarioBox from '../scenarioCards/approvedScenarioBox/approvedScenarioBox';
// import { removeSpecificApprovedTestOnSave } from '../../features/testCases/testCasesSlice';
// import CustomSnackbar from '../snackbar/CustomSnackbar';
// import {DEFAULT_STATUS, DEFAULT_PRIORITY} from '../../enums/enumRegistry'

// // New icons
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import { SaveAsOutlined } from '@mui/icons-material';

// const ApprovedTestCases = () => {
//   const { approvedTestCases } = useSelector((state) => state.testCases);
//   const dispatch = useDispatch();
//   const [isModalOpen, setModalOpen] = useState(false);
//   const [selectedTestCase, setSelectedTestCase] = useState(null);
//   const [isSaveModalOpen, setSaveModalOpen] = useState(false);
//   const [isBulkSave, setIsBulkSave] = useState(false); 
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success');
//   const auth = useSelector((state) => state.auth);

//   const openModal = (testCase) => {
//     setSelectedTestCase(testCase);
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   const handleOpenSaveModal = (testCase = null, bulkSave = false) => {
//     setSelectedTestCase(testCase);
//     setIsBulkSave(bulkSave);
//     setSaveModalOpen(true);
//   };

//   const handleCloseSaveModal = () => {
//     setSaveModalOpen(false);
//   };

//   const handleSaveTestCase = async (module_id) => {
//     if (isBulkSave) {
//       // Bulk save logic
//       console.log(approvedTestCases);
      
//       const bulkTestCases = approvedTestCases.map((testCase) => ({
//         ...testCase,
//         module_id,
//         generated_by: auth.user.id,
//         updated_by :  auth.user.id,
//         status: DEFAULT_STATUS,
//         priority : DEFAULT_PRIORITY,

//       }));

//       try {
//         const response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/testcase/bulkSave`,
//           bulkTestCases
//         );
//         console.log('Bulk test cases saved successfully:', response.data);

//         approvedTestCases.forEach((testCase) => {
//           dispatch(removeSpecificApprovedTestOnSave(testCase));
//         });

//         setSnackbarMessage('All test cases saved successfully!');
//         setSnackbarSeverity('success');
//       } catch (error) {
//         console.error('Error saving bulk test cases:', error);
//         setSnackbarMessage('Failed to save test cases. Please try again.');
//         setSnackbarSeverity('error');
//       }
//     } else if (selectedTestCase) {
//       // Single save logic
//       console.log(selectedTestCase);
//       const testCaseWithModule = { 
//       ...selectedTestCase,
//       module_id,
//       generated_by: auth.user.id,
//       updated_by :  auth.user.id,
//       status: DEFAULT_STATUS,
//       priority : DEFAULT_PRIORITY,
//      };

//       try {
//         const response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/testcase/save`,
//           testCaseWithModule
//         );
//         console.log('Test case saved successfully:', response.data);
//         dispatch(removeSpecificApprovedTestOnSave(selectedTestCase));

//         setSnackbarMessage('Test case saved successfully!');
//         setSnackbarSeverity('success');
//       } catch (error) {
//         console.error('Error saving test case:', error);
//         setSnackbarMessage('Failed to save test case. Please try again.');
//         setSnackbarSeverity('error');
//       }
//     }

//     setSnackbarOpen(true);
//     handleCloseSaveModal();
//   };

//   const handleExportToExcel = () => {
//     const dataForExport = approvedTestCases.map((testCase, index) => ({
//       ID: index + 1,
//       Type: testCase.type,
//       Title: testCase.title,
//       Description: testCase.description,
//     }));

//     exportToExcel(dataForExport, 'ApprovedTestCases.xlsx', 'Approved Test Cases');
//   };

//   const handleBulkSave = () => {
//    //implement to save approved test cases
//    setSaveModalOpen(true);
//   };

//   const handleSaveAllTestCases = async (module_id) => {
//     if (approvedTestCases.length > 0) {
//       // Prepare the payload with all test cases and the selected module ID
//       const bulkTestCases = approvedTestCases.map((testCase) => ({
//         ...testCase,
//         module_id,
//       }));
  
//       try {
//         const response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/testcase/bulkSave`, // Assuming bulk save endpoint
//           bulkTestCases
//         );
  
//         console.log('Test cases saved successfully:', response.data);
  
//         // Remove saved test cases from Redux state
//         approvedTestCases.forEach((testCase) => {
//           dispatch(removeSpecificApprovedTestOnSave(testCase));
//         });
  
//         setSnackbarMessage('All test cases saved successfully!');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//       } catch (error) {
//         console.error('Error saving test cases:', error);
  
//         setSnackbarMessage('Failed to save test cases. Please try again.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       } finally {
//         // Close the modal
//         handleCloseSaveModal();
//       }
//     }
//   };
  

//   return (
//     <section className="w-full min-h-96 mx-auto bg-green-100 p-6 rounded-lg shadow-md">
//       <div className="flex justify-between items-center mb-4">
//         <h3 className="text-2xl font-semibold text-green-700">
//           Approved Test Scenarios
//           <span className="text-xl text-green-500 pl-2">({approvedTestCases.length})</span>
//         </h3>

//         {/* Conditionally render the Export button if there are approved test cases */}
//         {approvedTestCases.length > 0 && (
//           <div className=''>
//             <Tooltip title="Export to Excel" arrow>
//               <button
//                 onClick={handleExportToExcel}
//                 style={{ backgroundColor: '#2160f3', color: 'white' }}
//                 className="px-2 mx-2 py-2 rounded-lg transition hover:bg-blue-700"
//               >
//                 <FileDownloadIcon fontSize="small" />
//               </button>
//             </Tooltip>
//             <Tooltip title="Save All" arrow>
//             <button
//               onClick={() => handleOpenSaveModal(null, true)}
//               style={{ backgroundColor: '#2160f3', color: 'white' }}
//               className="px-2 py-2 rounded-lg transition hover:bg-blue-700"
//             >
//               <SaveAsOutlined fontSize="small" />
//             </button>
//           </Tooltip>
//         </div>
//         )}
//       </div>

//       <div className="max-h-screen overflow-y-auto space-y-6">
//         {approvedTestCases.length > 0 ? (
//           approvedTestCases.map((testCase) => (
//             <ApprovedScenarioBox
//               key={testCase.id}
//               testCase={testCase}
//               openModal={openModal}
//               dispatch={dispatch}
//               handleOpenSaveModal={handleOpenSaveModal}
//             />
//           ))
//         ) : (
//           <div className="flex items-center justify-center h-64">
//             <p className="text-center text-gray-600">
//               No approved test cases available.
//             </p>
//           </div>
//         )}
//       </div>

//   {/* Modal for GPT Suggestions */}
//       <Modal isOpen={isModalOpen} onClose={closeModal} testCase={selectedTestCase} />
//       <SaveTestCaseModal
//         open={isSaveModalOpen}
//         onClose={handleCloseSaveModal}
//         onSave={handleSaveTestCase}
//       />

//       {/* Snackbar */}
//       <CustomSnackbar
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </section>
//   );
// };

// export default ApprovedTestCases;




import React, { useState } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { 
  Box, 
  Typography, 
  IconButton, 
  Tooltip, 
  Chip, 
  Link 
} from '@mui/material';
import { 
  DataGrid, 
  gridClasses
} from '@mui/x-data-grid';
import { 
  Topic,
  FileDownloadOutlined as Export,
  VisibilityOutlined as View,
  Close,
  Save,
  Delete,
 } from '@mui/icons-material';

// Utilities
import { useSnackbar } from "../../utils/useSnackbar";
import { exportToExcel } from '../../utils/exportToExcel';
import { removeSpecificApprovedTestOnSave } from '../../features/testCases/testCasesSlice';
import {DEFAULT_STATUS, DEFAULT_PRIORITY} from '../../enums/enumRegistry'
import { reviewTestCase, discardApprovedTestCase } from '../../features/testCases/testCasesSlice';
import { bulkSaveTestCase } from '../../utils/api/testcase_api';
import { STATUS } from '../../utils/api/sharedfunction';
// components
import SaveTestCaseModal from '../Modal/SaveTestCaseModal';
import DataGridContainer from '../datagrid/dataGridContainer/DataGridContainer';
import ExpandableCell from '../datagrid/ExpandableCell/ExpandableCell';
import TableComponent from '../TableComponent';
import ConfirmationModal from '../Modal/ConfirmationModal';
import { EyeIcon, XMarkIcon, ArrowDownTrayIcon, DocumentCheckIcon } from '@heroicons/react/24/outline';

const ApprovedTestCases = () => {
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { approvedTestCases } = useSelector((state) => state.testCases);
  const [selectedRows, setSelectedRows] = useState([]);

  const [isSaveModalOpen, setSaveModalOpen] = useState(false);
  const [selectedTestCase, setSelectedTestCase] = useState(null);
  const [rowData, setRowData] = useState(approvedTestCases);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isBulkSave, setIsBulkSave] = useState(false); 
  const [discardModalOpen, setDiscardModalOpen] = useState(false);

  const auth = useSelector((state) => state.auth);

  const openModal = (testCase) => {
    setSelectedTestCase(testCase);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleOpenSaveModal = (testCase = null, bulkSave = false) => {
    setSelectedTestCase(testCase);
    setIsBulkSave(bulkSave);
    setSaveModalOpen(true);
  };

  const handleCloseSaveModal = () => {
    setSaveModalOpen(false);
  };

  const getSelectedCaseData = (selectedRows) => {
    return approvedTestCases.filter(tc => selectedRows.includes(tc.id));
  };

  // Handle save 
  const handleSaveTestCase = async (module_id) => {
    if (isBulkSave || selectedRows.length > 0) {
      // Bulk save logic
      console.log('belk save mod id-',module_id);
      let testcaseToSave = selectedRows.length > 0 ? getSelectedCaseData(selectedRows) : approvedTestCases;
      const bulkTestCases = testcaseToSave.map((testCase) => ({
        ...testCase,
        module_id,
        generated_by: auth.user.id,
        updated_by :  auth.user.id,
        status: DEFAULT_STATUS,
        priority : DEFAULT_PRIORITY,

      }));


      try {
        const response = await bulkSaveTestCase({ testCases: bulkTestCases });

        if (response.status === STATUS.SUCCESS) {
          // Remove saved test cases from Redux state
          testcaseToSave.forEach((testCase) => {
            dispatch(removeSpecificApprovedTestOnSave(testCase));
            setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
          });
          // Clear selected rows
          setSelectedRows([]);
          
          showSnackbar(response.message || 'Test Scenarios saved successfully!', 'success');
        } else {
          console.error('Error saving bulk test cases:', response.error);
          showSnackbar(response.error || 'Failed to save test scenarios. Please try again!', 'error');
        }
      } catch (error) {
        console.error('Error saving bulk test cases:', error);
        showSnackbar('Failed to save test scenarios. Please try again!', 'error');
      }
    }

    handleCloseSaveModal();
  };

  // Handle export 
  const handleExportToExcel = () => {

    let hasSelection = selectedRows.length > 0;
    let testcaseToExport = hasSelection ? getSelectedCaseData(selectedRows) : approvedTestCases;

    const dataForExport = testcaseToExport.map((testCase, index) => ({
      ID: index + 1,
      Type: testCase.type,
      Title: testCase.title,
      Description: testCase.description,
    }));

    exportToExcel(dataForExport, 'ApprovedTestCases.xlsx', 'Approved Test Cases');
    // Clear selected rows
    setSelectedRows([]);

    let message = hasSelection ? `${selectedRows.length} Test Scenario Exported successfully` : 'All Test Scenarios Exported successfully';
    showSnackbar(message, 'success');
  };

  // Handle review 
  const handleReview = () => {
    let testcaseToReview = selectedRows.length > 0 ? getSelectedCaseData(selectedRows) : approvedTestCases;
    let reviewedCount = 0;
    testcaseToReview.forEach((testCase) => {
      dispatch(reviewTestCase(testCase));
      reviewedCount++;
      setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
    });
    // Clear selected rows
    setSelectedRows([]);
    showSnackbar(`Successfully submitted ${reviewedCount} test cases for review`, "success");
  };

  // Handle discard
  const handleDiscard = (testCase) => {
    let testcaseToDiscard = selectedRows.length > 0 ? getSelectedCaseData(selectedRows) : approvedTestCases;
    testcaseToDiscard.forEach((testCase) => {
      dispatch(discardApprovedTestCase(testCase));
      setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
    });
    setDiscardModalOpen(false);
    // Clear selected rows
    setSelectedRows([]);
    showSnackbar(`Successfully discarded ${testcaseToDiscard.length} test cases`, "success");
  };

  const handleReviewIndividual = (testCase) => {
    dispatch(reviewTestCase(testCase));
    
    // Delay the state update to avoid DataGrid issues
    setTimeout(() => {
      setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
    }, 0);
  };
  
  const handleDiscardIndividual = (testCase) => {
    dispatch(discardApprovedTestCase(testCase));
    
    // Delay the state update to avoid DataGrid issues
    setTimeout(() => {
      setRowData((prevRowData) => prevRowData.filter((row) => row.id !== testCase.id));
    }, 0);
  };

  // Row action buttons
  const rowActionButtons = [
    {
      name: 'Review',
      tooltip: 'Review Test Case',
      icon: <View fontSize="small" />,
      action: (testCase) => handleReviewIndividual(testCase),
    },
    {
      name: 'Discard',
      tooltip: 'Discard Test Case',
      icon: <Delete fontSize="small" />,
      action: (testCase) => handleDiscardIndividual(testCase),
    },
  ];

  // Header action buttons
  const headerActionButtons = [
    {
      name: 'Bulk Review',
      tooltip: selectedRows.length > 0 ? 'Review Selected Scenarios' : 'Review All',
      icon: <EyeIcon style={{ width: 18, height: 18 }} />, // replaced
      action: () => handleReview(),
      disabled: !approvedTestCases || approvedTestCases.length === 0,
    },
    {
      name: 'Discard',
      tooltip: 'Discard Selected Scenarios',
      icon: <XMarkIcon style={{ width: 18, height: 18 }} />, // replaced
      action: () => setDiscardModalOpen(true),
      disabled: selectedRows.length === 0,
    },
    {
      name: 'Bulk Save',
      tooltip: selectedRows.length > 0 ? 'Save Selected Scenarios' : 'Save All',
      icon: <DocumentCheckIcon style={{ width: 18, height: 18 }} />, // replaced
      action: () => handleOpenSaveModal(null, true),
      disabled: !approvedTestCases || approvedTestCases.length === 0,
    },
    {
      name: 'Export',
      tooltip: selectedRows.length > 0 ? 'Export Selected Scenarios' : 'Export All',
      icon: <ArrowDownTrayIcon style={{ width: 18, height: 18 }} />, // replaced
      action: handleExportToExcel,
      disabled: !approvedTestCases || approvedTestCases.length === 0,
    },
  ];

  // Columns for the DataGrid
  const columns = [
    { field: 'type', headerName: 'Type', width:200 },
    { field: 'title', headerName: 'Title', width: 250 },
    { 
      field: 'description', 
      headerName: 'Description', 
      flex: 1, 
      minWidth: 300,
      renderCell: (params) => (
        <ExpandableCell value={params.value} />
      )
    },
    // {
    //   field: 'actions',
    //   headerName: 'Actions',
    //   width: 150,
    //   sortable: false,
    //   align: 'center',
    //   headerAlign: 'center',
    //   renderCell: (params) => (
    //     <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
    //       {rowActionButtons.map((button, index) => (
    //         <Tooltip key={index} title={button.tooltip}>
    //           <IconButton
    //             className={`${button.color} ${button.hoverColor}`}
    //             onClick={() => button.action(params.row)}
    //             size="small"
    //           >
    //             {button.icon}
    //           </IconButton>
    //         </Tooltip>
    //       ))}

    //       {/* Render the Save button separately */}
    //       <Tooltip title="Save" arrow>
    //         <button
    //           onClick={() => handleOpenSaveModal(params.row)}

    //         >
    //           <Save fontSize="small" color= 'text-green-600' />
    //         </button>
    //       </Tooltip>
    //     </Box>
    //   ),
    // },
  ];

   const headerContent = () => {
      return (
        <div>
          <Chip
            label={`Count: ${approvedTestCases.length}`}
            size="small"
            variant="filled"
            color="primary"
            sx={{
              borderRadius: 1,
              fontWeight: 'bold',
              backgroundColor: '#e0e0e0',
              color: '#424242',
            }}
          />
        </div>
      );
    };

  return (
    <>
      <Box
        sx={{
          mb: 4,
        }}
      >
        <TableComponent
          title="Approved Test Scenarios for Review"
          headerActionButtons={headerActionButtons}
          headerContent={headerContent}
          rows={rowData}
          columns={columns}
          viewType="approvedAITestCase"
          isCheckbox={true}
          isRowSelection={true}
          handleRowSelection={(selectionModel) => setSelectedRows(selectionModel)}
          selectedRows={selectedRows}
          disableSelectionOnClick={true}
          getRowHeight={() => 'auto'}
          getEstimatedRowHeight={() => 100}
          isRowSelectable={(row) => { return rowData.map(item => item.id).includes(row.id);}}
          tableHeight={'90vh'}
          customStyles={{
            '& .MuiDataGrid-cell': {
              padding: 1,
              display: 'flex',
              alignItems: 'center',
            },
          }}
          isData={approvedTestCases && approvedTestCases.length > 0}
          customNoData={ 
            <Box
              sx={{
                height: 200,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                bgcolor: '#f9f9f9',
                mx: 2,
                my: 4,
              }}
            >
              <Topic sx={{ fontSize: 48, color: '#9e9e9e', mb: 2 }} />
              <Typography variant="body1" color="textSecondary">
                Please approve your generated scenarios to proceed with further review.
              </Typography>
            </Box>
          }
          disablePagination={true}
          disableFooter={true}
        />

        {/* Save Test Case Modal */}
        <SaveTestCaseModal
          open={isSaveModalOpen}
          onClose={handleCloseSaveModal}
          onSave={handleSaveTestCase}
        />

      </Box>
      <ConfirmationModal
        open={discardModalOpen}
        onClose={() => setDiscardModalOpen(false)}
        onConfirm={handleDiscard}
        title="Confirm Discard Action"
        message="You are about to discard the selected test cases. This action is irreversible. Do you wish to proceed?"
      />
    </>
  );
};

export default ApprovedTestCases;